<template>
  <div>
    <el-submenu v-if="id == 110">
      <template slot="title">
        <a :index="item.id + ''" @click="clicks">
          <!-- <i class="el-icon-right"></i> -->
          {{ item.name == "产品列表" ? "资产管理" : item.name }}
        </a>
      </template>
    </el-submenu>
    <el-submenu v-else :index="item.id + ''">
      <template slot="title">
        <a @click="click(item)">
          <!-- <i class="el-icon-right"></i> -->
          {{ item.name == "产品列表" ? "资产管理" : item.name  }}
        
        </a>
      </template>

      <template v-for="child in item.children" v-if="item.id != 110">
        <header-sidebar-item
          v-if="child.children && child.children.length > 0"
          :item="child"
          :key="child.id"
          @change="change"
        />

        <el-menu-item
          v-else
          :key="child.id"
          :index="child.id + ''"
          @click="click(child)"
        >
          <i class="el-icon-minus"></i>
          {{ child.name }}
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: "HeaderSidebarItem",
  data() {
    return {
      token: Number,
      showItemId: null,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    id: {
      type: Number,
      required: 0,
    },
    name: {
      type: String,
      required: "",
    },
  },
  mounted() {
    // 假设从某个全局状态管理器或本地存储获取token
    this.token = localStorage.getItem("token");
  },
  methods: {
    change(item) {
      this.click(item.item);
    },
    click(item) {
      console.log(item);
      this.$emit("change", {
        item,
        id: this.id,
        name: this.name,
      });
    },
    back(i, idx) {
      this.n = idx;
      this.$router.push(i);
      this.showItemId = false;
    },
    clicks() {
      this.back("/WineCulture?type=" + this.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HeaderSidebarItem.vue